import { registerBlockType } from '@wordpress/blocks';
import './style.scss';
import Edit from './edit.jsx';
import Save from './save.jsx';
import metadata from './block.json';

registerBlockType( metadata.name, {
	...metadata,
	edit: Edit,
	save: Save,
} );
